import * as React from "react";

import { ManualBankForm } from "client/domain/FormBuilder/BankInformation";
import { BankConnector } from "client/domain/FormBuilder/BankInformation/BankConnector";
import { BankInfoAccordion } from "client/domain/FormBuilder/BankInformation/BankInfoAccordion";
import { useMerchantModel, useRestore } from "client/hooks";
import { determineSecondBankFormEligibility } from "client/lib/apt-merchant/src/fields/bankInformation/utils";

export const BankInformation: React.FC = () => {
  const { merchant } = useMerchantModel();
  const registeredCountry =
    merchant.companyInformation.registeredCountry?.value;
  const salesChannel = merchant.storeDetails.salesChannel?.value;
  const { refetchRestore } = useRestore();

  React.useEffect(() => {
    // get restore values to prefill bank account name
    refetchRestore();
  }, [refetchRestore]);

  return determineSecondBankFormEligibility({
    salesChannel,
    registeredCountry,
  }) ? (
    <BankInfoAccordion />
  ) : (
    <BankConnector
      fieldSetName="PrimaryBankFieldSet"
      fallbackForm={<ManualBankForm />}
    />
  );
};
